/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//
import Button from '@material-ui/core/Button';
//----------------------------------------------------------------------//
//----------------------------------------------------------------------//
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';

import styles from '../../../../ActionDrawer.module.scss';

@translate()
@inject('actionDrawerStore', 'costCenterDetailsStore')
@observer
export default class RemoveProjectSuccess extends React.Component<*> {
  componentDidMount() {
    const actionDrawerStore: TypeActionDrawerStore = this.props.actionDrawerStore;
    const projects: Object = actionDrawerStore.response.cost_centre.projects;
    // const projectsCount: number = actionDrawerStore.response.cost_centre.projects_count;
    const projectsCount: number = projects.length;
    const costCenterDetails: Object = this.props.costCenterDetailsStore.details;
    costCenterDetails.projects = projects; // eslint-disable-line camelcase
    costCenterDetails.projects_count = projectsCount; // eslint-disable-line camelcase
  }

  renderItems = () => {
    const { t }: TranslatorProps = this.props;
    const actionDrawerStore: TypeActionDrawerStore = this.props.actionDrawerStore;
    const projects: Object = actionDrawerStore.response.projects;
    return projects.map((project: Object) => (
      <ul key={project.id}>
        <li>
          <b>{t('general:project')}</b>:
        </li>
        <li>{`${project.code} - ${project.name}`}</li>
      </ul>
    ));
  };

  render(): React.Node {
    const { t }: TranslatorProps = this.props;
    const actionDrawerStore: TypeActionDrawerStore = this.props.actionDrawerStore;
    const costCenter: Object = actionDrawerStore.response.cost_centre;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={false}
            gutters={true}
            heading={t('general:projects.multiple_removed')}
          >
            <p>{t('general:projects.messages.multiple_removed', { title: costCenter.name })}</p>
            <React.Fragment>{this.renderItems()}</React.Fragment>
          </ActionDrawerBlock>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
